module.exports = __webpack_public_path__ + "static/media/nio.ecdb97f3.svg";